import { createFileRoute, redirect } from "@tanstack/react-router"

import { isEqual } from "lodash"
import { useAuthStore } from "@/stores/authStore"

export const Route = createFileRoute("/admin/screen-presets")({
  beforeLoad: ({ search }) => {
    if (!useAuthStore.getState().hasPermission("view:full_admin_panel")) {
      throw redirect({ to: "/" })
    }

    const localStorageFilters = JSON.parse(
      localStorage.getItem("filters") || "{}",
    ) as typeof search

    if (isEqual(localStorageFilters.orgs, search.orgs)) return

    throw redirect({
      to: ".",
      search: { orgs: localStorageFilters.orgs },
    })
  },
})
